import React, { useState } from 'react';
import LazyLoad from 'react-lazyload';
import { getAmplitudeInstance } from '@alltrails/shared/utils/amplitudeHelpers';
import { string } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import arrowUp from './arrow_up.png';
import arrowDown from './arrow_down.png';
import { MOBILE_FEATURES } from '../../../utils/constants/PageSection';
import { HOMEPAGE_SIGNUP_BUTTON_TAPPED } from '../../../utils/constants/AmplitudeEvent';
import { EN_US } from '../../../utils/constants/LanguageRegionCode';

const {
  strings: {
    HOME_PAGE: {
      EXPLORE_AND_DISCOVER: {
        SEARCH_DISCOVER_NAV,
        NAVIGATE_TRACK_NAV,
        REMEMBER_INSPIRE_NAV,
        SEARCH_DISCOVER_TITLE,
        NAVIGATE_TRACK_TITLE,
        REMEMBER_INSPIRE_TITLE,
        SEARCH_DISCOVER_TEXT,
        NAVIGATE_TRACK_TEXT,
        REMEMBER_INSPIRE_TEXT
      }
    },
    SIGNUP: { SIGNUP }
  }
} = StringConstantsMixin;

const SLIDE_TITLES = [SEARCH_DISCOVER_TITLE, NAVIGATE_TRACK_TITLE, REMEMBER_INSPIRE_TITLE];
const SLIDE_TEXTS = [SEARCH_DISCOVER_TEXT, NAVIGATE_TRACK_TEXT, REMEMBER_INSPIRE_TEXT];
const CDN_BASE = 'https://cdn-assets.alltrails.com/assets/images/homepage/explore_and_discover/';

const DesktopFeatures = ({ languageRegionCode }) => {
  const shortRegionCode = languageRegionCode.split('-')[0];

  const [currentNav, setCurrentNav] = useState(0);
  const [nextNav, setNextNav] = useState(0);
  const [opacity, setOpacity] = useState(1);

  const partialImagePath = ['search_discover', 'navigate', 'remember'][currentNav];
  const imageUrl = `${CDN_BASE}${partialImagePath}_${shortRegionCode}.${currentNav === 1 ? 'gif' : 'png'}`;
  const title = SLIDE_TITLES[currentNav];
  const text = SLIDE_TEXTS[currentNav];

  const handleNavClick = (event, index) => {
    event.preventDefault();
    setNextNav(index);
    setOpacity(0);
  };

  const handlePrevNextClick = (event, previousOrNext) => {
    event.preventDefault();
    let previousOrNextNav = currentNav + (previousOrNext === 'previous' ? -1 : 1);

    if (previousOrNextNav < 0) {
      previousOrNextNav = 2;
    } else if (nextNav >= 2 && previousOrNext === 'next') {
      previousOrNextNav = 0;
    }

    setNextNav(previousOrNextNav);
    setOpacity(0);
  };

  const handleTransitionEnd = () => {
    if (opacity === 0) {
      setOpacity(1);
      setCurrentNav(nextNav);
    }
  };

  return (
    <div className={styles.bottomContainer}>
      <div className={styles.nav}>
        <a
          href="#previous"
          onClick={event => {
            handlePrevNextClick(event, 'previous');
          }}
        >
          <LazyLoad>
            <img className={styles.upArrowImage} src={arrowUp} alt="" />
          </LazyLoad>
        </a>
        <a
          className={`${styles.navLink} ${currentNav === 0 ? styles.active : ''}`}
          href="#search-and-discover"
          onClick={event => {
            handleNavClick(event, 0);
          }}
        >
          {SEARCH_DISCOVER_NAV}
        </a>
        <a
          className={`${styles.navLink} ${currentNav === 1 ? styles.active : ''}`}
          href="#navigate-and-track"
          onClick={event => {
            handleNavClick(event, 1);
          }}
        >
          {NAVIGATE_TRACK_NAV}
        </a>
        <a
          className={`${styles.navLink} ${styles.last} ${currentNav === 2 ? styles.active : ''}`}
          href="#remember-and-inspire"
          onClick={event => {
            handleNavClick(event, 2);
          }}
        >
          {REMEMBER_INSPIRE_NAV}
        </a>
        <a
          href="#next"
          onClick={event => {
            handlePrevNextClick(event, 'next');
          }}
        >
          <LazyLoad>
            <img className={styles.downArrowImage} src={arrowDown} alt="" />
          </LazyLoad>
        </a>
      </div>
      <div className={styles.screen}>
        <LazyLoad>
          <img style={{ opacity }} className={styles.screenImage} src={imageUrl} alt="" onTransitionEnd={handleTransitionEnd} />
        </LazyLoad>
      </div>
      <div style={{ opacity }} className={styles.feature}>
        <div className={styles.featureContent}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.featureText}>{text}</p>
          <a
            href={LanguageSupportUtil.wrapUrlSafe('/signup?ref=homepage_signup_desktopfeatures', languageRegionCode)}
            className={styles.signUpLink}
            onClick={() => getAmplitudeInstance().logEvent(HOMEPAGE_SIGNUP_BUTTON_TAPPED, { 'page section': MOBILE_FEATURES })}
          >
            {SIGNUP}
          </a>
        </div>
      </div>
    </div>
  );
};

DesktopFeatures.propTypes = {
  languageRegionCode: string
};

DesktopFeatures.defaultProps = {
  languageRegionCode: EN_US
};

export default DesktopFeatures;
